<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          v-if="allow('A')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="approved"
          >
            {{ '通过转正' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SpuDetail
      v-if="spuDetailOpts.visible"
      :type="spuDetailOpts.type"
      :visible.sync="spuDetailOpts.visible"
      :amzSpuCode="spuDetailOpts.amzSpuCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import SpuDetail from '../detail'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SpuDetail },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      spuDetailOpts: {
        visible: false,
        type: '',
        amzSpuCode: '',
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSpuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    async approved() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要通过转正的SPU',
          type: 'warning',
        })
        return
      }
      const listAmzSpuCode = this.checkedRows.map((row) => row.amzSpuCode)

      const confirm = await this.$confirm(
        '是否要通过转正？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSpuApprovedApi({ listAmzSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('通过失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '通过成功！',
        type: 'success',
      })
      this.reload()
    },
    openEditDialog({ type, data = {} } = {}) {
      const { amzSpuCode } = data
      this.spuDetailOpts = { visible: true, type, amzSpuCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
